/**
 * Badge - A reusable badge component for notifications, status indicators, etc.
 * 
 * @param {string} text - The text content of the badge
 * @param {string} variant - The color variant: "new" (red), "info" (blue), "success" (green), "warning" (yellow)
 * @param {string} size - Size variant: "small", "medium"
 * @param {object} style - Additional inline styles to apply
 * @param {string} className - Additional CSS classes
 */
function Badge({ 
  text, 
  variant = "new", 
  size = "small",
  style = {}, 
  className = "" 
}) {
  const variantStyles = {
    new: {
      backgroundColor: "#ff4b4b",
      color: "white",
    },
    info: {
      backgroundColor: "#3b82f6",
      color: "white",
    },
    success: {
      backgroundColor: "#22c55e",
      color: "white",
    },
    warning: {
      backgroundColor: "#f59e0b",
      color: "white",
    },
  };

  const sizeStyles = {
    small: {
      padding: "2px 8px",
      fontSize: "10px",
    },
    medium: {
      padding: "4px 12px",
      fontSize: "13px",
    },
  };

  const baseStyle = {
    borderRadius: "50px",
    fontWeight: "600",
    display: "inline-block",
    lineHeight: "1.4",
    ...variantStyles[variant],
    ...sizeStyles[size],
    ...style,
  };

  return (
    <span className={`badge ${className}`} style={baseStyle}>
      {text}
    </span>
  );
}

export default Badge;

